(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.InstagramPublicPost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Instagram public post data',
            channelName: sourceDetails[sources.INSTAGRAM].name,
            postName: sourceDetails[sources.INSTAGRAM].postName,

            storageDimensions: [
                'postId'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day', 'week', 'month',
                'dayOfWeek', 'hourOfDay',
                'mediaType',
                'engagementType',
                'postTagId',
                'hashtag',
                'keyword'
            ],

            fields: {
                postId: {
                    dataType: dataType.STRING
                },
                native_id: {
                    dataType: dataType.STRING
                },
                companyId: {
                    dataType: dataType.STRING
                },
                companyName: {
                    dataType: dataType.STRING
                },
                published_at: {
                    name: 'Published At',
                    collection: collection.GENERAL,
                    dataType: dataType.DATE
                },
                engagement_total: {
                    name: 'Engagement Total',
                    dataType: dataType.INTEGER,
                    collection: collection.ENGAGEMENT
                },
                applause: {
                    name: 'Likes',
                    dataType: dataType.INTEGER,
                    collection: collection.ENGAGEMENT_DETAILS
                },
                conversation: {
                    name: 'Comments',
                    dataType: dataType.INTEGER,
                    collection: collection.ENGAGEMENT_DETAILS
                },
                presence_reach: {
                    name: 'Followers',
                    dataType: dataType.INTEGER,
                    collection: function (metric) {
                        if (_.includes(metric.dimensions, 'post')) {
                            return collection.GENERAL;
                        }
                        return collection.AUDIENCE;
                    }
                },
                engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Follower',
                    dataType: dataType.NUMERIC,
                    collection: collection.ENGAGEMENT
                },
                has_hashtags: {
                    // 1 if this post has any hashtags, 0 otherwise.
                    dataType: dataType.INTEGER
                },
                engagement_rate_by_presence_reach_lift: {
                    name: 'Engagement Rate Lift',
                    dataType: dataType.NUMERIC,
                    collection: collection.ENGAGEMENT
                },
                other_posts_engagement_rate_by_presence_reach: {
                    name: 'Engagement Rate by Follower w/o tag',
                    dataType: dataType.NUMERIC,
                    collection: collection.ENGAGEMENT
                },
                video_views: {
                    name: 'Video Views',
                    dataType: dataType.TOTAL,
                    collection: collection.VIDEO_VIEWS_DETAILS
                },
                message: {
                    name: 'Message',
                    dataType: dataType.STRING
                },
                postLink: {
                    name: 'Post Link',
                    dataType: dataType.STRING
                },
                mediaType: {
                    name: 'Type',
                    dataType: dataType.STRING
                },
                link: {
                    name: 'Link',
                    dataType: dataType.STRING
                },
                canonicalUrl: {
                    name: 'Posted URL',
                    dataType: dataType.STRING
                },
                linkTitle: {
                    name: 'Link Title',
                    dataType: dataType.STRING
                },
                postedTitle: {
                    dataType: dataType.STRING
                },
                captured_at: {
                    dataType: dataType.DATE
                },
                platformImageUrl: {
                    dataType: dataType.STRING
                },
                imageUrl: {
                    dataType: dataType.STRING
                },
                linkDescription: {
                    name: 'Link Description',
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                presence_handle: {
                    name: 'Presence Handle',
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                estimated_impressions: {
                    name: 'Estimated Impressions',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                },
                engagement_rate_by_estimated_impression: {
                    name: 'Engagement Rate by Estimated Impression',
                    collection: collection.GENERAL,
                    dataType: dataType.NUMERIC
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost,
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
